/**
 * Test displaying localized content on the homepage:
 * https:www.notion.so/faire/UK-site-localization-dd05f8132c2d4888bcab75375805ae30
 */ export var ENABLE_HOMEPAGE_LOCALIZED_CONTENT_241015 = 'ENABLE_HOMEPAGE_LOCALIZED_CONTENT_241015';
